import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Messages from './Messages';
import s from './RegisterForm.css';
import { optionsParser } from '../../core/utils';
import Form from '../Form';
import Select from '../Select';
import Input from '../Input';
import LoginElements from '../LoginElements';
import { getNameValidations } from '../../core/validations';
import {
  ILEXCONNECT_URL,
  SPIROTECH_URL,
  TEST_SPIROTECH_URL,
} from '../../constants/websites';

class RegisterFormView extends React.Component {

  getCheckbox = (hostname, messages) => {
    switch (hostname) {
      case SPIROTECH_URL:
      case TEST_SPIROTECH_URL:
        return (
          <div className={s.formGroup}>
            <input id="checkbox_agree" type="checkbox" />
            <span>
              <FormattedMessage {...messages.spirotech_user_agreement_part1} />
            </span>
            <span>
              <a href='/privacy/gdpr'>
                <FormattedMessage {...messages.spirotech_user_agreement_part2} />
              </a>
            </span>
          </div>
        )
      default:
        return (
          <div className={s.formGroup}>
            <input id="checkbox_agree" type="checkbox" />
            <span>
              <FormattedMessage {...messages.husty_user_agreement} />
            </span>
          </div>
        );
    }
  };

  getWrappedRoot = hostname => {
    let wrappedClass = null;
    switch (hostname) {
      case ILEXCONNECT_URL:
        wrappedClass = cx(s.root);
        break;
      case SPIROTECH_URL:
      case TEST_SPIROTECH_URL:
        wrappedClass = cx(s.root, s.spirotech);
        break;
      default:
        wrappedClass = cx(s.root);
        break;
    }
    return wrappedClass;
  };

  getWrappedForm = hostname => {
    let wrappedClass = null;
    switch (hostname) {
      case ILEXCONNECT_URL:
        wrappedClass = cx(s.formGroup);
        break;
      case SPIROTECH_URL:
      case TEST_SPIROTECH_URL:
        wrappedClass = cx(s.formGroupSpirotech);
        break;
      default:
        wrappedClass = cx(s.formGroup);
        break;
    }
    return wrappedClass;
  };

  renderSubmitButton = text => {
    return (
      <div className={s.formGroup}>
        <button className={s.button} type="submit">
          <FormattedMessage {...text} />
        </button>
      </div>
    );
  };

  render() {
    const { intl, registerData, runtime } = this.props;
    const outerErrorMessage = registerData.get('errorMessage');
    const outerInfoMessage = registerData.get('infoMessage');

    const host = runtime.host;
    const hostname = runtime.hostname;

    // const host = SPIROTECH_URL;
    // const hostname = SPIROTECH_URL;

    const language = registerData.get('language');
    const accounttype = registerData.get('accounttype');
    const languageOptions = language.toArray().map(optionsParser);
    const accounttypeOptions = accounttype.toArray().map(optionsParser);
    const messages = Messages();

    // https://github.com/christianalfoni/formsy-react/blob/master/API.md
    const nameValidations = getNameValidations(intl, messages);
    const passwordValidation = {
      validations: {
        minLength: 8,
      },
      validationErrors: {
        minLength: intl.formatMessage({
          ...messages.field_min_length_8,
        }),
      },
    };

    const isInfo = outerErrorMessage || outerInfoMessage;
    const styled = {'margin-top':'80px'};
    const wrappedClassInfo = cx(s.Form_info);
    const wrappedClassError = cx(s.Form_info, s.Form_info__error);

    const wrappedRoot = this.getWrappedRoot(hostname);
    const wrappedForm = this.getWrappedForm(hostname);

    return (
      <div className={wrappedRoot}>
        <div className={s.container}>
          <LoginElements elementType={'LOGO'} hostname={hostname}/>
          <div className={s.marginTop}>
            {outerErrorMessage ? (
              <section className={wrappedClassError}>
                <div className={s.flex}>
                  <FormattedMessage {...messages[outerErrorMessage]} />
                </div>
                <LoginElements elementType={'BUTTONS_CLEAR'} />
              </section> ) : null}
            {outerInfoMessage ? (
              <section className={wrappedClassInfo}>
                <div className={s.flex}>
                  <FormattedMessage {...messages[outerInfoMessage]} />
                </div>
                <LoginElements elementType={'BUTTONS_CLEAR'} />
              </section> ) : null}
            {!isInfo ? (
              <Form onSubmit={this.props.onSubmit} style={styled}>
                <div className={wrappedForm}>
                  <label className={s.label} htmlFor="username">
                    <FormattedMessage
                      {...messages.email_placeholder_register_text} 
                    />
                  </label>
                  <Input
                    name="email"
                    title={intl.formatMessage({
                      ...messages.email_placeholder_register_text,
                    })}
                    type="text"
                    large
                    autofocus
                    maxLength="25"
                    {...nameValidations}
                    required
                  />
                </div>
                <div className={wrappedForm}>
                  <label className={s.label} htmlFor="password">
                    <FormattedMessage {...messages.password_register_text} />
                  </label>
                  <Input
                    name="password"
                    title={intl.formatMessage({ 
                      ...messages.password_register_text 
                    })}
                    type="password"
                    large
                    {...passwordValidation}
                    required
                  />
                </div>
                <div className={wrappedForm}>
                  <Select
                    name="language"
                    title={intl.formatMessage({
                      ...messages.language_register_text,
                    })}
                    options={languageOptions}
                    large
                    required
                  />
                </div>
                <div className={wrappedForm}>
                  <Select
                    name="accounttype"
                    title={intl.formatMessage({
                      ...messages.account_type_register_text,
                    })}
                    options={accounttypeOptions}
                    large
                    required
                   />
                </div>
                {this.getCheckbox(hostname, messages)}
                {this.renderSubmitButton(messages.register_submit_button_text)}
              </Form>) : ( <Form/> ) }
            <LoginElements elementType={'BUTTONS_REGISTER'} />
          </div>
        </div>
      </div>
    );
  }
}

RegisterFormView.propTypes = {
  registerData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  runtime: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  intl: intlShape.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default injectIntl(withStyles(s)(RegisterFormView));


// WEBPACK FOOTER //
// ./src/components/RegisterForm/RegisterFormView.js